export const OPPO_WL_CLID = 'oppo-wl'

export const DEFAULT_CLIDS = {
    direct: 'direct',
    directTest: 'direct-test',
}

export const UNKNOWN_CLID = 'unknown'

const NATIVE_IOS_CLIDS = {
    directIos: 'direct-app-ios',
    directIosTest: 'direct-app-ios-test',
}

const NATIVE_ANDROID_CLIDS = {
    directAndroid: 'direct-app-android',
    directAndroidTest: 'direct-app-android-test',
    twa: 'direct_twa',
}

export const NATIVE_APP_CLIDS = {
    ...NATIVE_ANDROID_CLIDS,
    ...NATIVE_IOS_CLIDS,
}

export const PWA_APP_CLIDS = {
    pwa: 'direct_pwa',
}

export const PLAYGAMA_CLIDS = {
    ...DEFAULT_CLIDS,
    ...PWA_APP_CLIDS,
    ...NATIVE_APP_CLIDS,
}

export const WHITE_LABEL_CLIDS: Record<string, string> = {
    '2page': OPPO_WL_CLID,
}

export const MANIFEST_META_KEY = 'pwa-manifest'
export const DEFAULT_MAIN_PAGE_DESKTOP_CATEGORY_SIZE = 14
export const DEFAULT_MAIN_PAGE_MOBILE_CATEGORY_SIZE = 7
export const DEFAULT_TRENDING_SIZE = 16
export const TRENDING_REQUEST_SIZE = 30
// divisible by 2, 3, 4, 6 to make a nice grid with big cards
export const DEFAULT_CATEGORY_PAGE_SIZE = 45
export const DEFAULT_RECOMMENDATION_SIZE = 16
export const DISABLE_AD_USD_PRICE_COEFFICIENT = 0.01

// used for game previews
const PLAYGAMA_VIDEO_SIZES = {
    320: {
        width: 569,
        height: 320,
    },
    640: {
        width: 1138,
        height: 640,
    },
} as const

export const PLAYGAMA_VIDEO = (id: string, height: keyof typeof PLAYGAMA_VIDEO_SIZES) => ({
    url: `https://static.playgama.com/p-video/${id}/orig_length_h${height}_6so.mp4`,
    height,
    width: PLAYGAMA_VIDEO_SIZES[height].width,
})

export const TEST_GAMES = ['iap-testing', 'ad-testing', 'bridgecorev1']

export const YOUTUBE_URL = 'https://www.youtube.com/@playgama_games'
export const YOUTUBE_HEADER_URL =
    'https://www.youtube.com/watch?v=NKhvc2roIsc&list=PLBIvtJFYmtawQqMBE5MC0VwlhIOHVj9Aq&index=1'
